import { render, staticRenderFns } from "./EditSeguradoraPage.vue?vue&type=template&id=a86bb164"
import script from "./EditSeguradoraPage.vue?vue&type=script&lang=js"
export * from "./EditSeguradoraPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports